<template>
  <div class="page-add-gys">
    <div class="form-section">
      <a-form :form="form" layout="horizontal">
        <a-form-item label="供应商名称" :label-col="{span: 3}" :wrapper-col="{span: 21}" required>
          <a-input
            v-decorator="[
              'gysName',
              {
                rules: [
                  { required: true, message: '请输入供应商名称！' },
                  { max: 100, message: '最多100个字符' },
                  { validator: checkGysNameUnique }
                ]
              }
            ]"
            placeholder="请输入"
            maxlength="100"
            style="width: 240px;"
          />
        </a-form-item>
        <a-form-item label="供应商手机号" :label-col="{span: 3}" :wrapper-col="{span: 21}" required>
          <a-input
            v-decorator="[
              'userName',
              {
                validateFirst: true,
                rules: [
                  { required: true, message: '请输入供应商手机号！' },
                  { validator: checkPhoneValid }
                ]
              }
            ]"
            placeholder="请输入"
            maxlength="11"
            style="width: 240px;"
            @input="handlePhoneInput"
          />
          <span class="input-tip">提示：初始密码默认为Aiit#123456</span>
        </a-form-item>
        <a-form-item label="导入价格清单" :label-col="{span: 3}" :wrapper-col="{span: 21}">
          <a-button type="primary" icon="upload" @click="importModalVisible = true">导入</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 报价列表 -->
    <div class="table-section">
      <a-table
        :columns="itemColumns"
        :dataSource="pagedItemList"
        :pagination="false"
        rowKey="key"
        bordered
      >
        <template slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleDeleteItem(record.key, record.id)">删除</a>
        </template>
      </a-table>
      <div class="pagination-wrapper">
        <a-pagination
          :current="itemPagination.current"
          :total="itemList.length"
          :pageSize="itemPagination.pageSize"
          :pageSizeOptions="['10', '20', '50']"
          :showTotal="total => `总共${total}条数据`"
          showSizeChanger
          showQuickJumper
          @change="handleItemPageChange"
          @showSizeChange="handleItemSizeChange"
        />
      </div>
    </div>

    <div class="footer-actions">
      <a-button type="primary" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit" style="margin-left: 16px;">提交</a-button>
    </div>

    <!-- 导入弹窗 -->
    <a-modal
      :title="null"
      :visible="importModalVisible"
      :confirmLoading="importing"
      okText="确定"
      cancelText="取消"
      :width="520"
      @ok="handleImportConfirm"
      @cancel="handleImportCancel"
    >
      <div class="import-modal-body">
        <div class="import-modal-title">批量导入</div>
        <a-divider style="margin: 0 0 20px 0;" />
        <!-- 上传文件 -->
        <div class="import-row">
          <span class="import-row-label">上传文件：</span>
          <div class="import-row-value">
            <a-upload
              :before-upload="handleFileSelect"
              :show-upload-list="false"
              :file-list="importFileList"
              accept=".xls,.xlsx"
            >
              <a-button>上传文件</a-button>
            </a-upload>
            <span v-if="importFileList.length > 0" class="selected-file-name">
              {{ importFileList[0].name }}
              <a-icon type="close-circle" class="remove-file-icon" @click="handleFileRemove" />
            </span>
          </div>
        </div>
        <!-- 导入模板下载 -->
        <div class="import-row">
          <span class="import-row-label">导入模版下载：</span>
          <div class="import-row-value">
            <a href="javascript:;" class="download-link" @click="handleDownloadTemp">模版下载 >></a>
          </div>
        </div>
        <!-- 导入说明 -->
        <div class="import-tips">
          <div class="tips-title">导入说明：</div>
          <div class="tips-item">1、请下载模版，填写后导入</div>
          <div class="tips-item">2、重复导入会更新原有数据，显示最新导入的数据</div>
          <div class="tips-item">3、仅支持上传1个文件</div>
        </div>
      </div>
    </a-modal>

    <!-- 二次确认弹窗 -->
    <a-modal
      :title="null"
      :visible="confirmModalVisible"
      :footer="null"
      :width="900"
      @cancel="handleConfirmCancel"
    >
      <div class="confirm-modal-body">
        <div class="import-modal-title">批量导入</div>
        <a-divider style="margin: 0 0 16px 0;" />
        <div class="confirm-title">是否确定导入以下{{ importPreviewList.length }}条信息？</div>
        <div class="confirm-subtitle">一经确定，将导入页面，请谨慎操作~</div>
        <a-table
          :columns="confirmColumns"
          :dataSource="confirmPagedList"
          :pagination="false"
          rowKey="previewKey"
          bordered
          size="small"
        >
          <template slot="index" slot-scope="text, record, index">
            {{ (confirmCurrentPage - 1) * confirmPageSize + index + 1 }}
          </template>
          <template slot="projectNameCell" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
              <span class="ellipsis-cell">{{ text }}</span>
            </a-tooltip>
          </template>
          <template slot="featureDescCell" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
              <span class="ellipsis-cell">{{ text }}</span>
            </a-tooltip>
          </template>
        </a-table>
        <div class="confirm-pagination">
          <a-pagination
            v-model="confirmCurrentPage"
            :total="importPreviewList.length"
            :pageSize="confirmPageSize"
            :page-size-options="['10', '20', '50', '100']"
            :show-total="total => `总共${total}条数据`"
            show-size-changer
            @change="handleConfirmPageChange"
            @showSizeChange="handleConfirmSizeChange"
          />
          <div class="quick-jumper-wrapper">
            <span>跳至</span>
            <a-input
              v-model="confirmJumpPage"
              @keyup.enter="handleConfirmQuickJump"
              class="quick-jumper-input"
            />
            <span>页</span>
            <a-button @click="handleConfirmQuickJump" size="small">跳转</a-button>
          </div>
        </div>
        <div class="confirm-footer">
          <a-button @click="handleConfirmCancel">取消</a-button>
          <a-button type="primary" style="margin-left: 12px;" @click="handleConfirmOk">确定</a-button>
        </div>
      </div>
    </a-modal>
    <!-- 导入失败弹窗 -->
    <a-modal
      title="导入失败"
      :visible="failModalVisible"
      :footer="null"
      :width="1000"
      @cancel="handleFailModalClose"
    >
      <div class="fail-modal-body">
        <div class="fail-title">导入失败</div>
        <div class="fail-subtitle">以下{{ failList.length }}条信息校验失败，请修改后重新导入全部文件</div>
        <a-table
          :columns="failColumns"
          :dataSource="failPagedList"
          :pagination="false"
          rowKey="failKey"
          bordered
          size="small"
        >
          <template slot="failIndex" slot-scope="text, record, index">
            {{ (failCurrentPage - 1) * failPageSize + index + 1 }}
          </template>
          <template slot="failProjectNameCell" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
              <span class="ellipsis-cell">{{ text }}</span>
            </a-tooltip>
          </template>
          <template slot="failFeatureDescCell" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
              <span class="ellipsis-cell">{{ text }}</span>
            </a-tooltip>
          </template>
          <template slot="failReasonCell" slot-scope="text">
            <a-tooltip placement="topLeft" :title="text">
              <span class="ellipsis-cell">{{ text }}</span>
            </a-tooltip>
          </template>
        </a-table>
        <div class="fail-pagination">
          <a-pagination
            v-model="failCurrentPage"
            :total="failList.length"
            :pageSize="failPageSize"
            :page-size-options="['10', '20', '50', '100']"
            :show-total="total => `总共${total}条数据`"
            show-size-changer
            @change="handleFailPageChange"
            @showSizeChange="handleFailSizeChange"
          />
          <div class="quick-jumper-wrapper">
            <span>跳至</span>
            <a-input
              v-model="failJumpPage"
              @keyup.enter="handleFailQuickJump"
              class="quick-jumper-input"
            />
            <span>页</span>
            <a-button @click="handleFailQuickJump" size="small">跳转</a-button>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'GysglAdd',
  data () {
    return {
      form: this.$form.createForm(this),
      isEdit: false,
      gysId: '',
      importing: false,
      importModalVisible: false,
      confirmModalVisible: false,
      confirmCurrentPage: 1,
      confirmPageSize: 10,
      confirmJumpPage: '',
      failModalVisible: false,
      failCurrentPage: 1,
      failPageSize: 10,
      failJumpPage: '',
      failList: [],
      importFileList: [],
      importPreviewList: [],
      itemList: [],
      itemPagination: { current: 1, pageSize: 10 },
      editableCols: ['projectName', 'featureDesc', 'unit', 'fullPrice'],
      confirmColumns: [
        { title: '序号', dataIndex: 'index', width: 60, align: 'center', scopedSlots: { customRender: 'index' } },
        {
          title: '分项工程名称',
          dataIndex: 'projectName',
          width: 160,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'projectNameCell' }
        },
        {
          title: '项目特征描述',
          dataIndex: 'featureDesc',
          width: 160,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'featureDescCell' }
        },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'fullPrice', width: 160, align: 'center' }
      ],
      failColumns: [
        { title: '序号', dataIndex: 'index', width: 60, align: 'center', scopedSlots: { customRender: 'failIndex' } },
        {
          title: '分项工程名称',
          dataIndex: 'projectName',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'failProjectNameCell' }
        },
        {
          title: '项目特征描述',
          dataIndex: 'featureDesc',
          width: 200,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'failFeatureDescCell' }
        },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'fullPrice', width: 150, align: 'center' },
        {
          title: '失败原因',
          dataIndex: 'failReason',
          width: 250,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'failReasonCell' }
        }
      ],
      previewColumns: [
        { title: '序号', dataIndex: 'index', width: 60, align: 'center', scopedSlots: { customRender: 'index' } },
        { title: '品目名称', dataIndex: 'projectName', width: 160, align: 'center', ellipsis: true },
        { title: '特性描述', dataIndex: 'featureDesc', width: 160, align: 'center', ellipsis: true },
        { title: '单位', dataIndex: 'unit', width: 80, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'fullPrice', width: 160, align: 'center' },
        { title: '操作', dataIndex: 'action', width: 70, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      itemColumns: [
        {
          title: '分项工程名称',
          dataIndex: 'projectName',
          width: 200,
          align: 'center',
          ellipsis: true,
          customRender: text => (
            <a-tooltip placement="topLeft" title={text}>
              <span class="ellipsis-cell">{text}</span>
            </a-tooltip>
          )
        },
        {
          title: '项目特征描述',
          dataIndex: 'featureDesc',
          width: 200,
          align: 'center',
          ellipsis: true,
          customRender: text => (
            <a-tooltip placement="topLeft" title={text}>
              <span class="ellipsis-cell">{text}</span>
            </a-tooltip>
          )
        },
        { title: '单位', dataIndex: 'unit', width: 100, align: 'center' },
        { title: '全费用综合单价（元）', dataIndex: 'fullPrice', width: 180, align: 'center' },
        { title: '操作', dataIndex: 'action', width: 80, align: 'center', scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    confirmPagedList () {
      const start = (this.confirmCurrentPage - 1) * this.confirmPageSize
      return this.importPreviewList.slice(start, start + this.confirmPageSize)
    },
    failPagedList () {
      const start = (this.failCurrentPage - 1) * this.failPageSize
      return this.failList.slice(start, start + this.failPageSize)
    },
    pagedItemList () {
      const start = (this.itemPagination.current - 1) * this.itemPagination.pageSize
      return this.itemList.slice(start, start + this.itemPagination.pageSize)
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.isEdit = true
      this.gysId = this.$route.query.id
      this.loadData(this.gysId)
      this.loadProjectInfoList(this.gysId)
    }
  },
  methods: {
    handlePhoneInput (e) {
      const value = e.target.value
      const filteredValue = value.replace(/\D/g, '')
      if (value !== filteredValue) {
        this.$nextTick(() => {
          this.form.setFieldsValue({ userName: filteredValue })
        })
      }
    },
    handleDownloadTemp () {
      const env = process.env.NODE_ENV
      const url = env === 'production' ? '/gysgl/projectInfo/downloadTemp.do' : '/api/gysgl/projectInfo/downloadTemp.do'
      window.open(url, '_blank')
    },
    handleFileSelect (file) {
      this.importFileList = [file]
      const formData = new FormData()
      formData.append('multipartFile', file)
      this.importing = true
      this.$axios.post('/api/gysgl/projectInfo/importExcel.do', formData).then(res => {
        console.log(res)
        const list = (res.data && res.data.list) || []
        if (list.length === 0) {
          this.$message.warning('未读取到数据，请检查文件内容')
        } else {
          this.importPreviewList = list.map((item, index) => ({
            previewKey: Date.now() + index,
            projectName: item.projectName || '',
            featureDesc: item.featureDesc || '',
            unit: item.unit || '',
            fullPrice: item.fullPrice || ''
          }))
        }
      }).catch((err) => {
        // 拦截器 reject 出来的就是后端返回体，真实错误在 err.msg
        const msg = (err && (err.msg || err.mes)) ||
          (err && err.response && err.response.data && err.response.data.msg) ||
          '解析失败，请检查文件格式'
        this.$message.error(msg)
        this.importFileList = []
      }).finally(() => {
        this.importing = false
      })
      return false
    },
    handleFileRemove () {
      this.importFileList = []
      this.importPreviewList = []
    },
    handlePreviewDelete (previewKey) {
      this.importPreviewList = this.importPreviewList.filter(item => item.previewKey !== previewKey)
    },
    handleImportCancel () {
      this.importModalVisible = false
      this.importFileList = []
      this.importPreviewList = []
    },
    handleImportConfirm () {
      if (this.importFileList.length === 0) {
        this.$message.warning('请先选择文件')
        return
      }
      if (this.importPreviewList.length === 0) {
        this.$message.warning('未读取到数据，请检查文件内容')
        return
      }
      this.importModalVisible = false
      this.confirmCurrentPage = 1
      this.confirmModalVisible = true
    },
    handleConfirmCancel () {
      this.confirmModalVisible = false
    },
    handleConfirmOk () {
      this.confirmModalVisible = false
      this.$axios.post('/api/gysgl/projectInfo/batchValidate.do', this.importPreviewList, {
        headers: { 'Content-Type': 'application/json' }
      }).then(res => {
        const failList = (res && res.data && res.data.failList) || []
        if (failList.length > 0) {
          this.showFailModal(failList.map((item, index) => ({ ...item, failKey: Date.now() + index })))
        } else {
          this.mergeImportedItems(this.importPreviewList)
          this.importPreviewList = []
          this.importFileList = []
          this.$message.success('导入成功')
        }
      })
    },
    mergeImportedItems (previewList) {
      // 重复判定：分项工程名称 + 项目特征描述 + 单位 三项完全一致视为同一项，重复时用最新单价覆盖
      const dedupKey = item => `${item.projectName}||${item.featureDesc}||${item.unit}`
      const merged = [...this.itemList]
      const indexMap = new Map()
      merged.forEach((item, idx) => indexMap.set(dedupKey(item), idx))
      previewList.forEach((item, i) => {
        const k = dedupKey(item)
        if (indexMap.has(k)) {
          const idx = indexMap.get(k)
          const target = merged[idx]
          merged[idx] = {
            ...target,
            fullPrice: item.fullPrice,
            _dirty: true
          }
        } else {
          const newItem = {
            projectName: item.projectName,
            featureDesc: item.featureDesc,
            unit: item.unit,
            fullPrice: item.fullPrice,
            key: Date.now() + i + Math.random()
          }
          indexMap.set(k, merged.length)
          merged.push(newItem)
        }
      })
      this.itemList = merged
    },
    handleConfirmPageChange (page) {
      this.confirmCurrentPage = page
    },
    handleConfirmSizeChange (current, size) {
      this.confirmCurrentPage = 1
      this.confirmPageSize = size
    },
    handleConfirmQuickJump () {
      const page = parseInt(this.confirmJumpPage)
      const maxPage = Math.ceil(this.importPreviewList.length / this.confirmPageSize)
      if (!page || isNaN(page) || page < 1) {
        this.$message.warning('请输入有效的页码')
        return
      }
      if (page > maxPage) {
        this.$message.warning(`页码超出范围，最大页码为${maxPage}`)
        return
      }
      this.confirmCurrentPage = page
      this.confirmJumpPage = ''
    },
    showFailModal (failList) {
      this.failList = failList
      this.failCurrentPage = 1
      this.failModalVisible = true
    },
    handleFailModalClose () {
      this.failModalVisible = false
      this.failList = []
    },
    handleFailPageChange (page) {
      this.failCurrentPage = page
    },
    handleFailSizeChange (current, size) {
      this.failCurrentPage = 1
      this.failPageSize = size
    },
    handleFailQuickJump () {
      const page = parseInt(this.failJumpPage)
      const maxPage = Math.ceil(this.failList.length / this.failPageSize)
      if (!page || isNaN(page) || page < 1) {
        this.$message.warning('请输入有效的页码')
        return
      }
      if (page > maxPage) {
        this.$message.warning(`页码超出范围，最大页码为${maxPage}`)
        return
      }
      this.failCurrentPage = page
      this.failJumpPage = ''
    },
    loadData (id) {
      this.$axios.post('/api/gysgl/detail.do', { id }).then(res => {
        const data = res.data.data
        this.form.setFieldsValue({
          gysName: data.gysName,
          userName: data.userName
        })
      })
    },
    loadProjectInfoList (gysId) {
      this.$axios.post('/api/gysgl/projectInfo/list.do', { gysId }).then(res => {
        const list = (res.data && res.data.list) || []
        this.itemList = list.map(item => ({ ...item, key: item.id }))
      })
    },
    handleDeleteItem (key, id) {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除该分项工程吗？',
        onOk: () => {
          if (id) {
            this.$axios.post('/api/gysgl/projectInfo/delete.do', { id }).then(() => {
              this.itemList = this.itemList.filter(item => item.key !== key)
              this.$message.success('删除成功！')
            })
          } else {
            this.itemList = this.itemList.filter(item => item.key !== key)
          }
        }
      })
    },
    handleCellChange (value, key, col) {
      const list = [...this.itemList]
      const target = list.find(item => String(item.key) === String(key))
      if (target) {
        target[col] = value
        this.itemList = list
      }
    },
    handleCancel () {
      this.$router.go(-1)
    },
    handleItemPageChange (page, pageSize) {
      this.itemPagination = { current: page, pageSize }
    },
    handleItemSizeChange (current, size) {
      this.itemPagination = { current: 1, pageSize: size }
    },
    // eslint-disable-next-line no-unused-vars
    checkGysNameUnique (rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      this.$axios.post('/api/gysgl/checkName.do', { gysName: value, id: this.gysId }).then(res => {
        if (res && res.data && res.data.exists) {
          // eslint-disable-next-line standard/no-callback-literal
          callback('供应商名称已存在！')
        } else {
          callback()
        }
      }).catch(() => {
        // eslint-disable-next-line standard/no-callback-literal
        callback('供应商名称校验失败，请稍后重试')
      })
    },
    // eslint-disable-next-line no-unused-vars
    checkPhoneValid (rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      const phone = String(value).trim()
      if (!/^\d+$/.test(phone)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('手机号只能由数字组成！')
        return
      }
      if (phone.length !== 11) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('手机号必须为11位！')
        return
      }
      // 国内手机号合法号段：13/14/15/16/17/18/19 开头
      if (!/^1[0-9]\d{9}$/.test(phone)) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入正确格式的手机号！')
        return
      }
      // 唯一性校验
      this.$axios.post('/api/gysgl/checkPhone.do', { userName: phone, id: this.gysId }).then(res => {
        if (res && res.data && res.data.exists) {
          // eslint-disable-next-line standard/no-callback-literal
          callback('该手机号已被其他供应商使用！')
        } else {
          callback()
        }
      }).catch(() => {
        // eslint-disable-next-line standard/no-callback-literal
        callback('手机号校验失败，请稍后重试')
      })
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = { ...values }
          if (this.$route.query.id) {
            params.id = this.$route.query.id
          }
          if (this.isEdit && !params.passWord) {
            delete params.passWord
          }
          this.$axios.post('/api/gysgl/save.do', params).then(res => {
            const savedId = params.id || (res && res.data && res.data.id)
            const gysId = savedId || this.gysId
            // 只保存新增项（无 id）和因导入重复被覆盖的旧项（_dirty），其余旧项跳过
            const savePromises = this.itemList
              .filter(item => !item.id || item._dirty)
              .map(item => {
                return this.$axios.post('/api/gysgl/projectInfo/save.do', {
                  id: item.id || '',
                  projectName: item.projectName,
                  featureDesc: item.featureDesc,
                  unit: item.unit,
                  fullPrice: item.fullPrice,
                  gysId: gysId
                })
              })
            Promise.all(savePromises).then(() => {
              this.$message.success(`${params.id ? '编辑' : '新增'}成功！`)
              this.$router.go(-1)
            }).catch(err => {
              const msg = (err && err.msg) || '保存价格清单失败，请稍后重试'
              this.$message.error(msg)
            })
          }).catch(err => {
            const msg = (err && err.msg) || (err && err.message) || '保存失败，请稍后重试'
            this.$message.error(msg)
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-add-gys {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 64px);

  .form-section {
    margin-bottom: 32px;

    .ant-form-item {
      margin-bottom: 16px;
    }

    .input-tip {
      color: rgba(0, 0, 0, 0.85);
      font-size: 12px;
      margin-left: 12px;
    }
  }

  .table-section {
    margin-bottom: 32px;

    .pagination-wrapper {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }

  .footer-actions {
    text-align: center;
    padding: 24px 0;
  }
}
</style>

<style lang="less">
.import-modal-body {
  .import-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
  }

  .import-row {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    .import-row-label {
      width: 120px;
      flex-shrink: 0;
      color: #333;
      font-size: 14px;
      text-align: left;
    }

    .import-row-value {
      flex: 1;
      display: flex;
      align-items: center;

      .selected-file-name {
        margin-left: 10px;
        color: #333;
        font-size: 13px;
        display: flex;
        align-items: center;

        .remove-file-icon {
          margin-left: 6px;
          color: #999;
          cursor: pointer;
          font-size: 14px;

          &:hover {
            color: #666;
          }
        }
      }
    }

    .download-link {
      color: #1890ff;
      font-size: 14px;
      text-decoration: none;

      &:hover {
        color: #40a9ff;
      }
    }
  }

  .import-tips {
    padding: 12px;
    background: #f5f5f5;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
    line-height: 1.8;
    margin-top: 20px;

    .tips-title {
      color: #333;
      font-weight: 500;
      margin-bottom: 4px;
    }

    .tips-item {
      color: #666;
    }
  }
}

.confirm-modal-body {
  .confirm-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 4px;
    text-align: center;
  }

  .confirm-subtitle {
    font-size: 12px;
    color: #999;
    margin-bottom: 16px;
    text-align: center;
  }

  .ant-table-thead > tr > th {
    background: #f5f5f5 !important;
  }

  .ant-table table {
    table-layout: fixed !important;
  }

  .ant-table-body {
    overflow-x: hidden !important;
  }

  .ant-table-tbody > tr > td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ellipsis-cell {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .confirm-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 12px;

    .quick-jumper-wrapper {
      display: flex;
      align-items: center;
      margin-left: 16px;

      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }

      .quick-jumper-input {
        width: 50px;
        margin: 0 8px;
        text-align: center;
      }

      .ant-btn {
        margin-left: 8px;
      }
    }
  }

  .confirm-footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
  }
}

.fail-modal-body {
  text-align: center;

  .fail-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 6px;
  }

  .fail-subtitle {
    font-size: 13px;
    color: #666;
    margin-bottom: 20px;
  }

  .ant-table table {
    table-layout: fixed !important;
  }

  .ant-table-body {
    overflow-x: hidden !important;
  }

  .ant-table-tbody > tr > td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ellipsis-cell {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .fail-pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;

    .quick-jumper-wrapper {
      display: flex;
      align-items: center;
      margin-left: 16px;

      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }

      .quick-jumper-input {
        width: 50px;
        margin: 0 8px;
        text-align: center;
      }

      .ant-btn {
        margin-left: 8px;
      }
    }
  }
}
</style>
